module.exports = __webpack_public_path__ + "static/media/dwg.6bc3feb7.png";